module.exports = __webpack_public_path__ + "static/media/App.b7ff4eff.scss";


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 1042
// module chunks = 0